import { queryOptions } from "@tanstack/react-query";
import type { ApiClient } from "@/lib/api";
import { getEngineApi } from "@/lib/api";
import type { OrgProjectScope } from "@/lib/resource-context";
import { secretsKeys } from "./query-keys";

type MetadataPage = { total_count?: number };

const fetchSecretsCount = async ({
  client,
}: {
  client: ApiClient;
}): Promise<number> => {
  // total_count reflects the full set regardless of limit; fetch one row.
  const { data } = await client.get<MetadataPage>("/secrets/metadata", {
    params: { limit: 1, offset: 0 },
  });
  return data?.total_count ?? 0;
};

export const secretsCountQueryOptions = ({
  scope,
}: {
  scope: OrgProjectScope;
}) => {
  const client = getEngineApi(scope, "project");

  return queryOptions({
    queryKey: [...secretsKeys.lists({ scope }), "metadata-count"],
    queryFn: () => fetchSecretsCount({ client }),
  });
};
